import resolveSubjectTypeColor from '@Guidelines/Component/SubjectTypeTile/Helpers/resolveSubjectTypeColor';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import * as React from 'react';

const rowStyle = css`
	display: inline-flex;
	align-items: center;
	gap: 0.625rem;
`;

type Props = { color: string; label: string };

/** A dot of the subject type color followed by its label, for the color list and its trigger. */
const ColorSwatch: React.FC<Props> = ({ color, label }) => {
	const dotStyle = React.useMemo(
		() => css`
			flex: none;
			width: 1rem;
			height: 1rem;
			border-radius: ${theme.radii.pill};
			background-color: ${resolveSubjectTypeColor(color)};
		`,
		[color],
	);

	return (
		<span css={rowStyle}>
			<span css={dotStyle} aria-hidden="true" />
			{label}
		</span>
	);
};

export default ColorSwatch;
